// extracted by mini-css-extract-plugin
module.exports = {"spinner":"WaitForIt_spinner__1MdUK","sk-bouncedelay":"WaitForIt_sk-bouncedelay__2h_RI","bounce1":"WaitForIt_bounce1__3g0Kd","bounce2":"WaitForIt_bounce2__BRe7c"};